import * as R from "../Redux";
import { T, TB } from "../Constants";

type ToggleStateAction = string;
type State = T.CollapsedTabsRedux;
type Actions = T.CollapsedTabsActions;

const tabs_reducer: T.ReduxFn<State, Actions> = (state = [], payload) => {
    const { type = null, action = null } = payload || {};

    // Toggle a collapsed tab
    if (type === "TOGGLE_COLLAPSED_TAB") {
        const tab_id = action as ToggleStateAction;
        if (!TB.mongoIdValidator(tab_id)) return state;
        return state.includes(tab_id) ? state.filter(id => id !== tab_id) : state.concat(tab_id);
    }
    return state;
}

/** Toggle a collapsed tab */
export const toggle_collapsed_tab = (tab_id: ToggleStateAction) => R.store.then(s => s.dispatch({ type: "TOGGLE_COLLAPSED_TAB", action: tab_id, asyncDispatch: s.dispatch }));

export default tabs_reducer;